import type { PageLoad } from './$types';
import {environment} from "$lib/env";

let apiUrl = environment.apiUrl;

export const load: PageLoad = async ({ fetch, params, }) => {
    let slug = params.static;

    const response = await fetch(`${apiUrl}/static-pages/${slug}`);
    const content = await response.json();

    return { content: content.data?.content };
};
